export const EColors = {
  primary: 'primary',
  accent: 'accent',
  text: 'text',
  contrast: 'contrast',
  secondary: 'secondary',
  note: 'note',
  secondaryContrast: 'secondaryContrast',
  noteContrast: 'noteContrast',
  error: 'error',
  orange: 'orange',
  warning: 'warning',
  success: 'success',
  info: 'info',
  lavender: 'lavender',
} as const;

export type TColors = keyof typeof EColors;
